export default "__VITE_ASSET__96a32052__"